/* eslint-disable func-names */

// global document, requestAnimationFrame
export default function(overflowNav, overflowNavButton, mainNavItems) {
  if (!mainNavItems) {
    return;
  }

  const style = document.createElement('style');
  const template = ".sdc-site-header__menu-group-overflow .sdc-site-header__menu-item:nth-last-child(-n+#{num}){display:block}.sdc-site-header__menu-group[data-type='overflow-target']{visibility: #{visible}}";
  overflowNav.appendChild(style);

  function checkNav() {
    let hidden = 0;
    mainNavItems.forEach((item) => {
      if (item.offsetTop > 1) {
        hidden++;
      }
    });

    return hidden;
  }

  function writeCss() {
    const numberHidden = checkNav();
    let css = template;
    const visible = numberHidden ? 'visible' : 'hidden';

    css = css.replace(/#{num}/g, numberHidden).replace(/#{visible}/, visible);
    requestAnimationFrame(() => {
      style.textContent = css;
    });

    const items = document.querySelectorAll('.sdc-site-header__menu-cell--1 .sdc-site-header__menu-item');
    items.forEach(item => item.classList.remove('sdc-site-header__menu-item--hidden'));
    if (items.length - numberHidden > 0) {
      for (let i = items.length - numberHidden; i < items.length; i++) {
        items[i].classList.add('sdc-site-header__menu-item--hidden');
      }
    }
  }

  overflowNavButton.addEventListener('click', function overflowClickHandler() {
    if (this.getAttribute('aria-expanded') === 'true') {
      this.setAttribute('aria-expanded', 'false');
    } else {
      this.setAttribute('aria-expanded', 'true');
    }
  });

  document.body.addEventListener('click', (e) => {
    if (!overflowNav.contains(e.target)) {
      overflowNavButton.setAttribute('aria-expanded', 'false');
    }
  });

  let res;
  window.addEventListener('resize', () => {
    clearTimeout(res);
    res = setTimeout(() => {
      writeCss();
    }, 200);
  });

  writeCss();
}
